<template>
  <!-- Alan açıklaması (docs/styleguide/pencere.md → Alan açıklaması): etiketin yanında "?" düğmesi, metin üstüne gelince
       ya da odaklanınca ipucunda. Dokunmatikte dokunuş düğmeyi odaklar, başka yere dokununca kapanır. Etiketin içine
       konmaz: etiketteki düğmeye tıklamak alanı odaklar ve etiket içinde etkileşimli öğe geçersizdir. -->
  <button type="button" class="est-field-hint" v-tooltip.top="text" :aria-label="ariaLabel" @click.prevent>
    <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
  </button>
</template>

<script>
  export default {
    name: 'FieldHint',
    props: {
      text: { type: String, required: true },
      // Düğmenin erişilebilir adı alanın adını taşır; açıklamanın kendisini ipucu `aria-describedby` ile verir.
      label: { type: String, default: '' }
    },
    computed: {
      ariaLabel() {
        const what = this.$t('Explanation');
        return this.label ? `${this.label}: ${what}` : what;
      }
    }
  }
</script>

<style>
  /* Etiket + "?" tek satırda; etiketin alt payı satıra taşınır, alanla arası değişmez. */
  .est-label-row {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-bottom: .5rem;
  }

  .est-label-row > label,
  .est-label-row > legend {
    width: auto;
    margin-bottom: 0;
  }

  /* Sessiz ikon düğmesi: dokunma alanı 24px, simge soluk; üstüne gelince ve odakta teal. */
  .est-field-hint {
    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin: -4px 0;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--est-ink-3);
    font-size: 13px;
    line-height: 1;
    cursor: help;
  }

    .est-field-hint:hover,
    .est-field-hint:focus-visible {
      color: var(--est-action-ink);
    }

    .est-field-hint:focus-visible {
      outline: none;
      box-shadow: 0 0 0 2px var(--est-surface), 0 0 0 4px var(--est-action);
    }
</style>
